module.exports = __webpack_public_path__ + "media/country_flags/pl-98e51586.png";